module.exports = __webpack_public_path__ + "img/padlock.eff15704.svg";